import { render, staticRenderFns } from "./FreightInfo.vue?vue&type=template&id=ff34698c&scoped=true&"
import script from "./FreightInfo.vue?vue&type=script&lang=js&"
export * from "./FreightInfo.vue?vue&type=script&lang=js&"
import style0 from "./FreightInfo.vue?vue&type=style&index=0&id=ff34698c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff34698c",
  null
  
)

export default component.exports